import header from './header'
import navMenu from './navmenu'
import api from './api'

export default {
  header, navMenu, api
}



// WEBPACK FOOTER //
// ./src/vuexs/modules/index.js